module.exports = __webpack_public_path__ + "static/img/icon_search@2x.72d866b2.png";